// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationBannerPause: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#577538",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 10 12" width={width} height={height}>
            <path
                fill="currentColor"
                d="M1.5 1c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5H3c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zM0 1.5A1.5 1.5 0 0 1 1.5 0H3a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 3 12H1.5A1.5 1.5 0 0 1 0 10.5zM7 1c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h1.5c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm-1.5.5A1.5 1.5 0 0 1 7 0h1.5A1.5 1.5 0 0 1 10 1.5v9A1.5 1.5 0 0 1 8.5 12H7a1.5 1.5 0 0 1-1.5-1.5z"
            />
        </svg>
    );
};

export default React.memo(PaginationBannerPause);
